import React from 'react';
import "./Panel.css";

const cx = require('classnames');

export default class extends React.Component {
    render() {
        const {title, options, label} = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <div className="panel-title" style={{fontSize: '1.2em'}}>{title}</div>
                                {label && <div className={cx("label", "lb-md", label.className)}>{label.label}</div>}
                                <div className="panel-options">{options}</div>
                            </div>
                            <div className="panel-body">
                            {React.cloneElement(this.props.children, { props: this.props })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
